$(document).ready(function() {
  var elem = document.querySelector(".seccion-checkout.seccion-checkout-finalizar");
  if (elem == null) {
    return;
  }

  let owlCarruselImagenes;

  let vueAppCheckout = new Vue({
    el: elem,
    data: {

    },
    mounted() {
      Fancybox.bind('[data-fancybox="Terraza"]', {

      })
      Fancybox.bind('[data-fancybox="TerrazaTelefono"]', {

      })

      owlCarruselImagenes = $('.owl-carousel-telefono').owlCarousel({
        loop: false,
        margin: 0,
        dots: false,
        smartSpeed: 1500,
        nav: false,
        // dots: true,
        autoplay: true,
        items: 1,
        // navText : ['<div class="ms-nav-prev"></div>','<div class="ms-nav-next"></div>'],
      });

      var totalItems = $('.owl-item:not(.cloned)').length;

      $('#totalImages').text(totalItems);

      owlCarruselImagenes.on('changed.owl.carousel', function(event) {
        var currentIndex = event.item.index - event.relatedTarget._clones.length / 2;
        var currentItem = (currentIndex % totalItems + totalItems) % totalItems + 1; // Ajuste para índices negativos
        $('#currentImage').text(currentItem);
      })
    },
    methods: {
      checkout(e){
        swal({
          title: '¿Completar reservación?',
          icon: 'warning',
          buttons: { cancel: 'Cancelar', ok: 'Aceptar', },
          dangerMode: true,
        }).then((ok) => {
          if (ok) {
            $("#btnFinalizar").loader("show")
            var formData = new FormData($("#finalizarForm")[0])
            axios
              .post("/checkout/finalizar", formData)
              .then((respuesta) => {
                $("#btnFinalizar").loader("hide")
                if (respuesta.data.error) {
                  swal({
                    icon: "info",
                    title: respuesta.data.error,
                    button: {
                      text: "Aceptar",
                      closeModal: true,
                    },
                  })
                  return
                }
                location.href = "/eventos/" + respuesta.data.reservacion.id
              })
              .catch((error) => {
                ReportErrorLog(error)
                console.error(error)
                $("#btnFinalizar").loader("hide")
                swal({
                  icon: "info",
                  title: "Ocurrió un error inesperado",
                  button: {
                    text: "Aceptar",
                    closeModal: true,
                  },
                })
              })
          }
        });

      }
    }
  });

});
